// Footer component

const Footer = () => {
  return (
    <footer>
      <p> ☕ Created by Jingru </p>
    </footer>
  );
};

export default Footer;
